/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  let arrSelect = [];
  let globalCurrentOptionName = '';
  /* eslint-disable */
  class ProductSwatch extends HTMLElement {
    constructor() {
      super();
  
      /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
      this.onSwatchChangeBound = this.onSwatchChange.bind(this);
      this.onColorSwatchMouseEnterBound = this.onColorSwatchMouseEnter.bind(this);
      this.onSwatchMouseLeaveBound = this.onSwatchMouseLeave.bind(this);
    }
  
    connectedCallback() {
      this.colorLabel = this.querySelector('[data-color-swatch-name]');
      this.colorLabelState = this.querySelector('[data-color-swatch-state]');
      this.soldOutString = this.getAttribute('data-swatch-sold-out-string');
      this.colorSwatches = this.querySelectorAll('.swatch-element.color');
      this.sectionId = this.getAttribute('data-section-id');
      this.setEventListeners();
      this.setColorLabelState();
    }
  
    setEventListeners() {
      /* ===== Attach the event listeners to the DOM elements ===== */
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
        swatch.addEventListener('mouseleave', this.onSwatchMouseLeaveBound);
      });
  
      this.addEventListener('change', this.onSwatchChangeBound);
    }
  
    setColorLabelState() {
      /* ===== Set the color label state based on the active swatch ===== */
      const activeSwatch = this.querySelector('.swatch-element.color.active');
      if (!activeSwatch) return;
  
      const activeSwatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
      if (!this.soldOutString || !this.colorLabelState) return;
  
      // Set color label state (sold out or not)
      this.updateColorLabelState(activeSwatchAvailable);
    }
  
    updateColorLabelState(available) {
      /* ===== Set the color label state (sold out or not) ===== */
      if (this.colorLabelState) {
        this.colorLabelState.innerText = available === 'false' ? `(${this.soldOutString})` : '';
      }
    }
  
    // onSwatchChange(event) {
    //   const input = event.target;
    //   const parent = input.parentElement;
    //   const currentParentOptionValue = parent.getAttribute('data-option');
    //   const currentVariant = this.getVariantData(input.id);
    //   const productUrl = input.getAttribute('data-product-url');
    //   const productFetchUrl = input.getAttribute('data-product-fetch-url');
    //   const isCombinedListing = input.getAttribute('data-is-combined-listing') === 'true';
    //   this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);
    // }
    onSwatchChange(event) {
      const input = event.target;
      const parent = input.parentElement;
      const currentParentOptionName = parent.getAttribute('data-option');
      const currentParentOptionMedia = parent.getAttribute('data-media-id');
      const currentParentOptionValue = parent.getAttribute('data-value');
      const currentVariant = this.getVariantData(input.id);

      function slideToMedia(mediaId) {
        let swiperContainer = document.querySelector('.product-medias__main .swiper.main-media');
        if (!swiperContainer || !swiperContainer.swiper) return;
      
        let swiperInstance = swiperContainer.swiper;
        let targetSlide = swiperContainer.querySelector('.swiper-slide.product-medias__primary[data-media-id="' + mediaId + '"]');
      
        if (targetSlide) {
          let slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));
          let targetIndex = slides.indexOf(targetSlide);
      
          if (targetIndex !== -1) {
            if (currentParentOptionName == 'Color') {
              console.log('manual change main image');
              swiperInstance.slideTo(targetIndex);
            }
          }
        }
      }
  
      const existingIndex = globalArrayUserSelected.findIndex(function(option) {
        return option.name === currentParentOptionName;
      });
  
      if (existingIndex !== -1) {
        globalArrayUserSelected[existingIndex].value = currentParentOptionValue;
      } else {
        globalArrayUserSelected.push({
            name: currentParentOptionName,
            value: currentParentOptionValue
        });
      }
      // is for stopped mutationCallback in theme.liquid
      globalIsUrerSelectoptions = true;
      selectUserVariant();
      if (currentParentOptionName == 'Color' && availableSizesArr.length > 0) {
        for (let i = 0; i < availableSizesArr.length; i++) {
          let soldedItem = document.querySelector(`.swatch-items-wrapper .swatch-element[data-option="Size"][data-value="${availableSizesArr[i]}"]`);
          if (!isSizeAvailableForColor(availableSizesArr[i], currentParentOptionValue)) {
            soldedItem.classList.add('soldout');
          } else {
            soldedItem.classList.remove('soldout');
          }
        }
      }
  
      const productUrl = input.getAttribute('data-product-url');
      const productFetchUrl = input.getAttribute('data-product-fetch-url');
      const isCombinedListing = input.getAttribute('data-is-combined-listing') === 'true';

      let selectorColor = document.querySelector('[data-option-index="0"] .swatch-items-wrapper');
      let selectorSize = document.querySelector('[data-option-index="1"] .swatch-items-wrapper');
      let hasColorOption = !!selectorColor;
      let hasSizeOption = !!selectorSize;

      if (hasColorOption && hasSizeOption) {
        if (globalCurrentOptionName.length > 0) {
          if (globalCurrentOptionName != currentParentOptionName) {
            if (arrSelect.length < 2) {
              if (arrSelect.length == 0) {
                arrSelect[0] = {
                  currentVariant: currentVariant,
                  productFetchUrl: productFetchUrl,
                  productUrl: productUrl,
                  isCombinedListing: isCombinedListing,
                  currentParentOptionName: currentParentOptionName,
                  inputId: input.id,
                }

                slideToMedia(currentParentOptionMedia);

              }
              if (arrSelect.length == 1) {
                arrSelect[1] = {
                  currentVariant: currentVariant,
                  productFetchUrl: productFetchUrl,
                  productUrl: productUrl,
                  isCombinedListing: isCombinedListing,
                  currentParentOptionName: currentParentOptionName,
                  inputId: input.id,
                }
                this.emitVariantChangeEvent(arrSelect[1].currentVariant, arrSelect[1].productFetchUrl, arrSelect[1].productUrl, arrSelect[1].isCombinedListing);
                const previousInputId = arrSelect[0].inputId;
                const labelElement = document.querySelector(`label[for="${previousInputId}"]`);
                if (labelElement) {
                  labelElement.click(); // after emitVariantChangeEvent
                } else {
                  console.warn(`Label with for="${previousInputId}" not found.`);
                }
              }
            } else {
              this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);
            }
          } else {
            if (arrSelect.length < 2) {
              if (arrSelect.length > 0) {
                for (let i = 0; i < arrSelect.length; i++) {
                  if (arrSelect[i].currentParentOptionName == currentParentOptionName) {
                    arrSelect[i] = {
                      currentVariant: currentVariant,
                      productFetchUrl: productFetchUrl,
                      productUrl: productUrl,
                      isCombinedListing: isCombinedListing,
                      currentParentOptionName: currentParentOptionName,
                      inputId: input.id,
                    }

                    slideToMedia(currentParentOptionMedia);
                  }
                }
              }
            } else {
              this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);
            }
          }
        } else {
          arrSelect[0] = {
            currentVariant: currentVariant,
            productFetchUrl: productFetchUrl,
            productUrl: productUrl,
            isCombinedListing: isCombinedListing,
            currentParentOptionName: currentParentOptionName,
            inputId: input.id,
          }

          slideToMedia(currentParentOptionMedia);
        }
      } else if (hasColorOption || hasSizeOption) {
        this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);
      }
    

      globalCurrentOptionName = currentParentOptionName;
      // this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);
    }
  
    emitVariantChangeEvent(variant, productFetchUrl, productUrl, isCombinedListing = false) {
      /* ===== Emit the variant:change event ===== */
      eventBus.emit('variant:change', {
        sectionId: this.sectionId,
        variant: variant,
        fetchURL: productFetchUrl,
        productURL: productUrl,
        isCombinedListing: isCombinedListing
      });
    }
  
    onColorSwatchMouseEnter(event) {
      /* ===== Update the color label on mouse enter ===== */
      this.updateColorLabel(event.currentTarget);
      
      // Add sibling hover active class
      const activeSwatch = this.querySelector('.swatch-element.color.active');
      if (activeSwatch && !event.currentTarget.classList.contains('active')) activeSwatch.classList.add('sibling-hover-active');
    }
  
    onSwatchMouseLeave() {
      /* ===== Reset the color label on mouse leave ===== */
      // Remove sibling hover active class
      const siblingHoverActiveSwatch = this.querySelector('.swatch-element.sibling-hover-active');
      if (siblingHoverActiveSwatch) siblingHoverActiveSwatch.classList.remove('sibling-hover-active');
  
      // Reset color label
      this.resetColorLabel();
    }
  
    updateColorLabel = (swatch) => {
      /* ===== Update the color label based on the swatch value ===== */
      if (!swatch) return;
      const label = swatch.getAttribute('data-value');
      const swatchAvailable = swatch.getAttribute('data-swatch-option-available');
  
      if (!label || !this.colorLabel) return;
      // Set color label text
      this.colorLabel.textContent = label;
      // Set color label state (sold out or not)
      this.updateColorLabelState(swatchAvailable);
    }
  
    resetColorLabel = () => {
      /* ===== Reset the color label to the active swatch value ===== */
      const activeSwatch = this.querySelector('.swatch-element.color.active');
      if (!activeSwatch || !this.colorLabel) return;
  
      const activeSwatchValue = activeSwatch.getAttribute('data-value');
      const swatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
      if (!activeSwatchValue) return;
  
      // Reset color label text
      this.colorLabel.textContent = activeSwatchValue;
      // Reset color label state (sold out or not)
      this.updateColorLabelState(swatchAvailable);
    }	
  
    removeEventListeners() {
      /* ===== Remove the event listeners from the DOM elements ===== */
      this.colorSwatches.forEach(swatch => {
        swatch.removeEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
        swatch.removeEventListener('mouseleave', this.onSwatchMouseLeaveBound);
      });
  
      this.removeEventListener('change', this.onSwatchChangeBound);
    }
  
    getVariantData(inputId) {
      return JSON.parse(this.getVariantDataElement(inputId).textContent);
    }
  
    getVariantDataElement(inputId) {
      return this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
    }
  
    disconnectedCallback() {
      /* ===== Remove the event listeners when the element is removed from the DOM ===== */
      this.removeEventListeners();
    }
  }
  
  if (!window.customElements.get('product-swatch')) {
    window.customElements.define('product-swatch', ProductSwatch);
  }
  
  /******/ })()
  ;